<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMicrophoneOff_32"
    viewBox="0 0 32 32"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M21 16.833V8.5a5 5 0 0 0-5-5c-2.49 0-4.54 1.827-4.92 4.21l9.847 9.849.01-.065c.031-.218.063-.435.063-.66Zm3.333 0v-1.666a.834.834 0 0 0-1.666 0v1.666c0 .736-.149 1.432-.37 2.095l1.297 1.297a8.245 8.245 0 0 0 .74-3.392ZM6.407 5.393 27.089 26.08a.833.833 0 1 1-1.177 1.177l-4.305-4.305a8.258 8.258 0 0 1-4.774 2.169v3.38a.834.834 0 0 1-1.666 0v-3.417c-4.2-.426-7.5-3.94-7.5-8.25v-1.666a.834.834 0 1 1 1.666.001v1.667A6.673 6.673 0 0 0 16 23.5c1.708 0 3.233-.681 4.41-1.744l-1.163-1.164c-.875.76-1.996 1.242-3.247 1.242a5 5 0 0 1-5-5v-4.49L5.228 6.572a.834.834 0 0 1 1.179-1.179Z"
        clip-rule="evenodd"
    />
</svg>
